/*
 * Full-bleed homepage hero with the header floating over it.
 *
 * Dawn stacks the header above the first section. The reference brand runs its
 * hero to the top of the page and lets a transparent header sit on top of it,
 * turning solid once you scroll past. Two things are needed for that, and both
 * depend on a measurement, so they live here rather than in CSS:
 *
 *   --pfb-header-h  the header's height, used to pull the hero up under it
 *                   and to size the hero so it still fills the viewport
 *   .pfb-header-over-hero  on <body> while the header is still over the image
 *
 * Everything switches off on any page without a hero, and on small screens
 * where the drawer header needs its own solid background.
 */
(function () {
  'use strict';

  var body = document.body;
  if (!body.classList.contains('template-index')) return;

  var header = document.querySelector('.section-header');
  var hero = document.querySelector('#MainContent .shopify-section:first-child .banner');
  if (!header || !hero) return;

  var overlayQuery = window.matchMedia('(min-width: 990px)');
  var frame = null;

  function measure() {
    body.style.setProperty('--pfb-header-h', header.offsetHeight + 'px');
  }

  function update() {
    frame = null;
    if (!overlayQuery.matches) {
      body.classList.remove('pfb-header-over-hero');
      return;
    }
    // Solid as soon as the header would cross the bottom of the image.
    var limit = hero.offsetHeight - header.offsetHeight;
    body.classList.toggle('pfb-header-over-hero', window.scrollY < limit);
  }

  function onScroll() {
    if (frame === null) frame = requestAnimationFrame(update);
  }

  function onResize() {
    measure();
    update();
  }

  body.classList.add('pfb-has-hero');
  measure();
  update();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  if (overlayQuery.addEventListener) overlayQuery.addEventListener('change', onResize);

  // The logo is the last thing to settle the header's height.
  window.addEventListener('load', onResize);
})();
